"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
    Gender["OTHER"] = "other";
})(Gender = exports.Gender || (exports.Gender = {}));
var CreateCustomer = /** @class */ (function () {
    function CreateCustomer() {
        var _this = this;
        this.id = null;
        // This field is used to detect whether the browser should prompt the user when they exit the edit page
        this.changed = false;
        this.cardId = null;
        this.secureProfileImageFileName = null;
        this.idType = null;
        this.secureIdImageFileName = null;
        this.name = '';
        this.email = null;
        this.canContactEmail = false;
        this.phone = null;
        this.canContactPhone = false;
        this.city = null;
        this.province = null;
        this.address = null;
        this.country = null;
        this.postalCode = null;
        this.driversLicenseNumber = null;
        this.notes = null;
        this.loyaltyTierId = null;
        this.birthday = null;
        this.expiryDate = null;
        this.locationId = null;
        this.gender = null;
        this.isTaxExempt = false;
        setTimeout(function () {
            mobx_1.observe(_this, function () {
                _this.changed = true;
            });
        }, 1000);
    }
    CreateCustomer.prototype.populateFields = function (customer) {
        Object.assign(this, customer);
    };
    CreateCustomer.prototype.setCardId = function (cardId) {
        if (!cardId) {
            cardId = null;
        }
        this.cardId = cardId;
    };
    CreateCustomer.prototype.setSecureProfileImage = function (secureProfileImageFileName) {
        if (!secureProfileImageFileName) {
            secureProfileImageFileName = null;
        }
        this.secureProfileImageFileName = secureProfileImageFileName;
    };
    CreateCustomer.prototype.setIdType = function (idType) {
        this.idType = idType;
    };
    CreateCustomer.prototype.setSecureIdImageFileName = function (secureIdImageFileName) {
        if (!secureIdImageFileName) {
            secureIdImageFileName = null;
        }
        this.secureIdImageFileName = secureIdImageFileName;
    };
    CreateCustomer.prototype.setName = function (name) {
        this.name = name;
    };
    CreateCustomer.prototype.setEmail = function (email) {
        if (!email) {
            email = null;
        }
        this.email = email;
    };
    CreateCustomer.prototype.setPhone = function (phone) {
        if (!phone) {
            phone = null;
        }
        this.phone = phone;
    };
    CreateCustomer.prototype.setCity = function (city) {
        if (!city) {
            city = null;
        }
        this.city = city;
    };
    CreateCustomer.prototype.setProvince = function (province) {
        if (!province) {
            province = null;
        }
        this.province = province;
    };
    CreateCustomer.prototype.setAddress = function (address) {
        if (!address) {
            address = null;
        }
        this.address = address;
    };
    CreateCustomer.prototype.setCountry = function (country) {
        if (!country) {
            country = null;
        }
        this.country = country;
    };
    CreateCustomer.prototype.setPostalCode = function (postalCode) {
        if (!postalCode) {
            postalCode = null;
        }
        this.postalCode = postalCode;
    };
    CreateCustomer.prototype.setDriversLicenseNumber = function (driversLicenseNumber) {
        if (!driversLicenseNumber) {
            driversLicenseNumber = null;
        }
        this.driversLicenseNumber = driversLicenseNumber;
    };
    CreateCustomer.prototype.setNotes = function (notes) {
        if (!notes) {
            notes = null;
        }
        this.notes = notes;
    };
    CreateCustomer.prototype.setLoyaltyTierId = function (loyaltyTierId) {
        this.loyaltyTierId = loyaltyTierId;
    };
    CreateCustomer.prototype.setBirthday = function (birthday) {
        this.birthday = birthday;
    };
    CreateCustomer.prototype.setExpiryDate = function (expiryDate) {
        this.expiryDate = expiryDate;
    };
    CreateCustomer.prototype.setLocationId = function (locationId) {
        this.locationId = locationId;
    };
    CreateCustomer.prototype.setGender = function (gender) {
        this.gender = gender;
    };
    CreateCustomer.prototype.setIsTaxExempt = function (isTaxExempt) {
        this.isTaxExempt = isTaxExempt;
    };
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "changed", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "cardId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "secureProfileImageFileName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "idType", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "secureIdImageFileName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "email", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "canContactEmail", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "phone", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "canContactPhone", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "city", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "province", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "address", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "country", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "postalCode", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "driversLicenseNumber", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "loyaltyTierId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "birthday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "expiryDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "gender", void 0);
    __decorate([
        mobx_1.observable
    ], CreateCustomer.prototype, "isTaxExempt", void 0);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "populateFields", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setCardId", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setSecureProfileImage", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setIdType", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setSecureIdImageFileName", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setName", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setEmail", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setPhone", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setCity", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setProvince", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setAddress", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setCountry", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setPostalCode", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setDriversLicenseNumber", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setNotes", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setLoyaltyTierId", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setBirthday", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setExpiryDate", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setLocationId", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setGender", null);
    __decorate([
        mobx_1.action
    ], CreateCustomer.prototype, "setIsTaxExempt", null);
    return CreateCustomer;
}());
exports.CreateCustomer = CreateCustomer;
//# sourceMappingURL=Customer.js.map